import { useImageAnnotatorContext } from "@msuite/image-annotator";
import { Fragment } from "react";

export function DimensionAnnotationPreview() {
	/** Context */
	const context = useImageAnnotatorContext();

	/** Computed */
	const combinedScale = context.baseScale * context.scale;
	const point = context.controller.dimensionPoint;

	/** Guard */
	if (context.controller.tool !== "dimension") return null;
	if (!point) return null;

	/** Render */
	return (
		<Fragment>
			<circle
				cx={point.x}
				cy={point.y}
				r={7 / combinedScale}
				fill="none"
				stroke="var(--color-yellow-500)"
				strokeWidth={1.5 / combinedScale}
			/>
			<circle
				cx={point.x}
				cy={point.y}
				r={2 / combinedScale}
				fill="var(--color-yellow-500)"
			/>
		</Fragment>
	);
}
